/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { format } from "date-fns";
import axios from "axios";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  showStatus,
  encodeValue,
  showPriceValue,
  showLoader,
  hideLoader,
  checkPermission,
} from "../Settings/Settings";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "purchase/";
var moduleName = "Purchase";
var qs = require("qs");
var Parser = require("html-react-parser");
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      selectedItem: "",
      employeeList: [],
      selectedEmp: "",
      assignRemarks: "",
      assignHistory: [],
      amountHistory: [],
      totalAmount: 0,
      activeTab: "form",
      colectamount: "",
      modeofPayment: "",
      paymentreferencenumber: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadEmployee();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadEmployee() {
    var urlShringTxt =
      apiUrl + "employee/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ employeeList: res.data.result });
      }
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + module + "list",
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push({
      pathname: "/" + module + "edit",
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  handleChangeRemarks(historyIndex, event) {
    var assignHistory = this.state.assignHistory;
    var updassignHistory = [];
    if (assignHistory.length > 0) {
      assignHistory.map((item, index) => {
        if (historyIndex === index) {
          var historyDetails = item;
          historyDetails["assignRemarks"] = event.target.value;
          updassignHistory.push(item);
        } else {
          updassignHistory.push(item);
        }
        return "";
      });
    }
    this.setState({ assignHistory: updassignHistory });
  }

  setTab(type) {
    this.setState({ activeTab: type });
  }
  assignEng(item) {
    this.setState({ selectedItem: item }, () => {
      this.getassignEmployee();
      $("#modaldemo1").modal("show");
    });
  }
  getassignEmployee() {
    var urlShringTxt =
      apiUrl +
      module +
      "getassignEmployee?&userID=" +
      this.state.userID +
      "&saleID=" +
      this.state.selectedItem?.saleID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ assignHistory: res.data.result });
      }
    });
  }
  confirmAssing() {
    var postObject = {
      userID: this.state.userID,
      saleID: this.state.selectedItem?.saleID,
      empID: this.state.selectedEmp?.value,
    };
    showLoader("assignEmp");
    axios
      .post(
        apiUrl + "sale/assignEmployee",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assignEmp");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.setState(
            {
              selectedItem: "",
              selectedEmp: "",
            },
            () => {
              $("#modaldemo1").modal("hide");
              this.getassignEmployee();
            }
          );
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }
  completeWork(assignID, assignIndex) {
    var assignHistory = this.state.assignHistory;
    var assignRemarks = "";
    if (assignHistory.length > 0) {
      assignHistory.map((item, index) => {
        if (assignIndex === index) {
          assignRemarks = item?.assignRemarks;
        }
        return "";
      });
    }

    var postObject = {
      userID: this.state.userID,
      assignID: assignID,
      assignRemarks: assignRemarks,
    };
    showLoader("assignEmp");
    axios
      .post(
        apiUrl + "sale/updateassignStatus",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assignEmp");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.getassignEmployee();
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }
  collectAmount(item) {
    console.log(item, 'itemitem')
    this.setState({ selectedItem: item, colectamount:item.purchaseBalanceAmount }, () => {
      $("#modalamount").modal("show");
      this.getamountHistory();
    });
  }
  getamountHistory() {
    var urlShringTxt =
      apiUrl +
      module +
      "getamountHistory?&userID=" +
      this.state.userID +
      "&purchaseID=" +
      this.state.selectedItem?.purchaseID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({
          amountHistory: res.data.result,
          totalAmount: res.data.totalAmount,
        });
      }
    });
  }
  confirmCollectAmount() {
    var postObject = {
      userID: this.state.userID,
      purchaseID: this.state.selectedItem?.purchaseID,
      amount: this.state.colectamount,
      modeofPayment: this.state.modeofPayment?.value,
      paymentreferencenumber: this.state.paymentreferencenumber,
    };
    showLoader("assigncollect");
    axios
      .post(
        apiUrl + module+"/collectPurchaseAmount",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assigncollect");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.setState(
            {
              selectedItem: "",
              colectamount: "",
              modeofPayment: "",
              paymentreferencenumber: "",
            },
            () => {
              $("#modalamount").modal("hide");
              this.loadList(this.state.currentPage);
            }
          );
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="purchase" />
            <ToastContainer />
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    {checkPermission("sale", "add") === true && (
                      <div>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to={"/" + "products/purchase"}>
                              <button
                                className="btn btn-sm btn-primary badge"
                                type="button"
                              >
                                <i className="fa fa-plus"></i> Purchase New Stock
                              </button>
                            </Link>
                          </li>
                        </ol>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Search " + moduleName}
                                name="name"
                                onChange={this.handleChangeText}
                                value={this.state.name}
                              />
                            </div>
                            <div className="col-md-3">
                              <a
                                href={() => false}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={() => false}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Invoice Number</th>
                                      <th>Purchase Date</th>
                                      <th>Purchase Amount</th>
                                      <th>GST Amount</th>
                                      <th>Total Purchase Amount</th>
                                      <th>Paid Amount</th>
                                      <th>Balance Amount</th>
                                      <th>Vendor Name</th>
                                      <th>Vendor Person</th>
                                      <th>Mobile </th>
                                      <th>Email</th>
                                      <th>Address</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr
                                            key={index}
                                          >
                                            <td>
                                              <a
                                                className="nav-link dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                href="/"
                                                role="button"
                                                aria-expanded="false"
                                              >
                                                Action
                                              </a>
                                              <ul className="dropdown-menu">
                                                <li>
                                                  <a
                                                    className="dropdown-item"
                                                    href={() => false}
                                                    onClick={this.collectAmount.bind(
                                                      this,
                                                      item
                                                    )}
                                                  >
                                                    Pay Amount
                                                  </a>
                                                </li>
                                              </ul>
                                            </td>
                                            <td>{item.purchaseInvoiceNumber}</td>
                                            <td>
                                              {format(
                                                new Date(item.purchaseDate),
                                                "dd-MM-yyyy"
                                              )}
                                            </td>                                              
                                            <td>
                                              {showPriceValue(item.purchaseSubtotal)}
                                            </td>
                                            <td>
                                              {showPriceValue(item.purchaseGSTAmount)}
                                            </td>
                                            <td>
                                              {showPriceValue(item.purchaseAmount)}
                                            </td>
                                            <td>
                                              {showPriceValue(
                                                item.purchasePayAmount
                                              )}
                                            </td>
                                            <td>
                                              {showPriceValue(
                                                item.purchaseBalanceAmount
                                              )}
                                            </td>
                                            <td>{item.vendorName}</td>
                                            <td>
                                              {item.vendorContactPerson}
                                            </td>
                                            <td>{item.vendorPhone}</td>
                                            <td>{item.vendorEmail}</td>
                                            <td>
                                              {item.vendorAddress}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center"
                                          colSpan={12}
                                        >
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />                              
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="modalamount">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content modal-content-demo">
              <div className="modal-header">
                <h6 className="modal-title">Pay Amount</h6>
                <button
                  aria-label="Close"
                  className="btn-close"
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="tab-menu-heading">
                  <div className="tabs-menu">
                    <ul className="nav panel-tabs panel-info">
                      <li>
                        <a
                          href="#tab21"
                          className="active"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "form")}
                        >
                          <span>
                            <i className="fe fe-user me-1"></i>
                          </span>
                          New
                        </a>
                      </li>
                      <li>
                        <a
                          href="#tab22"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "list")}
                        >
                          <span>
                            <i className="fe fe-calendar me-1"></i>
                          </span>
                          History
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {this.state.activeTab === "form" && (
                  <div className="form-row mt-4">
                    <div className="form-group col-md-6">
                      <label className="form-label">
                        Amount<span className="lbl-error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Please Enter Amount"
                        name="colectamount"
                        autoComplete="off"
                        onChange={this.handleChangeText}
                        value={this.state.colectamount}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">
                        Mode of Payment<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.modeofPayment}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "modeofPayment"
                        )}
                        placeholder="Select Mode of Payment"
                        isClearable={true}
                        options={[
                          {
                            label: "NIFFT",
                            value: "NIFFT",
                          },
                          {
                            label: "Cheque",
                            value: "Cheque",
                          },
                          {
                            label: "Cash",
                            value: "Cash",
                          },
                        ]}
                      />
                    </div>
                    {(this.state.modeofPayment?.value === "NIFFT" ||
                      this.state.modeofPayment?.value === "Cheque") && (
                      <div className="form-group col-md-6">
                        <label className="form-label">
                          Payment Reference Number
                          <span className="lbl-error">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Payment Reference Number"
                          name="paymentreferencenumber"
                          autoComplete="off"
                          onChange={this.handleChangeText}
                          value={this.state.paymentreferencenumber}
                        />
                      </div>
                    )}
                  </div>
                )}
                {this.state.activeTab === "list" && (
                  <div className="table-responsive mt-4">
                    <table className="table text-nowrap text-md-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Paid Date</th>
                          <th>Amount</th>
                          <th>Mode of Payment</th>
                          <th>Payment Reference Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.amountHistory.length > 0 ? (
                          <>
                            {this.state.amountHistory.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {format(
                                      new Date(item.amountCreatedOn),
                                      "dd-MM-yyyy"
                                    )}
                                  </td>
                                  <td>{showPriceValue(item.amount)}</td>
                                  <td>{item.modeofPayment}</td>
                                  <td>{item.paymentReferenceNumber}</td>                                 
                                </tr>
                              );
                            })}
                            <tr>
                              <td colSpan={3}>
                                <b>Total</b>
                              </td>
                              <td>
                                <b>{showPriceValue(this.state.totalAmount)}</b>
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={4}>
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={this.confirmCollectAmount.bind(this)}
                  id="assigncollect"
                >
                  Update
                </button>{" "}
                <button className="btn btn-light" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
